export const formAction = (formId, data, params = {}) => ({
    method: 'POST',
    url: `/forms${formId ? `/${formId}` : ''}`,
    data,
    ...params
});

export const fetchUserFormList = ({ page, limit, search, searchType = 'participantEmail' }) => { 
    return ({
        method: 'GET',
        url: `/forms/user-forms?page=${page}&limit=${limit}&search=${search}&searchType=${searchType}`,
    }) }
;

export const fetchUserFormAnalytics = ({ page, limit }) => { 
    return ({
        method: 'GET',
        url: `/forms/user-forms/analytics`,
    }) }
;
